module.exports = __webpack_public_path__ + "img/video_camera_front.0b531421.svg";